import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';

const styles = require('./HeavyPanelView.less');
const cx = classnames.bind(styles);

export interface HeavyPanelViewProps extends PanelContentProps
{
    isVisible:boolean;
    heavyContent:JSX.Element;
}

@observer
export class HeavyPanelView extends React.Component<HeavyPanelViewProps, any>
{
    render()
    {
        const {heavyContent} = this.props;
        const props =   {
                            onPanelResize: this.props.onPanelResize,
                        };

        const newProps = Object.assign({}, heavyContent.props, props);
        return React.cloneElement(heavyContent, newProps);
    }
}
